module.exports = __webpack_public_path__ + "static/step5-682bd56a7a58b48d64eff630b1f33aa7.png";